import { ModuleLayout } from "../_shared/ModuleLayout";
export default function AiLayout() {
  return (
    <ModuleLayout
      testId="pureh-ai"
      eyebrow="AI · Headquarters"
      title="AI Operating System"
      subtitle="Your AI executive team — teammates, playbooks, conversations, insights, approvals."
      tabs={[
        { to: "overview",     label: "Overview" },
        { to: "teammates",    label: "Teammates" },
        { to: "playbooks",    label: "Playbooks" },
        { to: "conversations",label: "Conversations" },
        { to: "insights",     label: "Insights" },
        { to: "approvals",    label: "Approvals" },
      ]}
    />
  );
}
